import { makeStyles } from '@material-ui/core/styles';

import Button from 'components/CncUI/Button';

const useStyles = makeStyles(({ spacing }) => ({
  button: {
    borderRadius: 2,
    border: '1px solid #2eaba4',
    marginLeft: spacing(1),
  },
  cloudUploadIcon: {
    fontSize: 32,
    verticalAlign: 'middle',
  },
  uploadArea: { paddingTop: spacing(1), marginBottom: spacing(1) },
  uploadBox: {
    display: 'flex',
    alignItems: 'center',
  },
  uploadBoxContent: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

const UploadInput = ({ addFileHandler }) => {
  const classes = useStyles();
  const onFileDroppedHandler = e => {
    e.preventDefault();

    const dt = e.dataTransfer;
    const newFile = dt.files[0];

    addFileHandler(newFile);
  };

  const onFilePickedHandler = e => {
    if (e.target.files && e.target.files[0]) {
      const newFile = e.target.files[0];

      addFileHandler(newFile);
      e.target.value = '';
    }
  };
  return (
    <div
      className={classes.uploadArea}
      onDragOver={e => {
        e.preventDefault();
      }}
      onDrop={onFileDroppedHandler}
    >
      <div className={classes.uploadBox}>
        <div className={classes.uploadBoxContent}>
          <Button
            variant="outlined"
            className={classes.button}
            component="label"
          >
            Browse for File
            <input
              type="file"
              style={{ display: 'none' }}
              onChange={onFilePickedHandler}
            />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UploadInput;
